module.exports = __webpack_public_path__ + "static/freshman-4-6263db85981a73a7f8ab45290d967369.jpg";